import React, { useState } from 'react';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';
import {
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
  ScrollView,
} from 'react-native';
import { useTranslation } from 'react-i18next';
import { StripeClientSecretContext } from 'context/StripeContainer';

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 10,
    backgroundColor: '#fff',
  },
});

interface Props {
    setFieldValue: any;
    setFieldTouched: any;
    style?: object;
    afterSubmit: () => void;
}

const PaymentArea: React.FC<Props> = ({
    setFieldValue,
    setFieldTouched: _setFieldTouched,
    style: _style,
    afterSubmit,
}) => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();
  const clientSecret = React.useContext(StripeClientSecretContext);

  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState('');

  const handleSaveCard = async (): void => {
    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);
    setMessage('');

    try {
      if (!clientSecret) {
        throw new Error('Payment form is not ready yet. Please try again.');
      }

      const { error: submitError } = await elements.submit();
      if (submitError) {
        console.error(submitError.message);
        return;
      }

      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        clientSecret,
        redirect: 'if_required',
        // confirmParams: { return_url: ... }
      });

      if (error) {
        console.error(error.message);
      } else if (setupIntent) {
        console.log(
          'Setup succeeded! PaymentMethod:',
          setupIntent.payment_method
        );
        const payment = {
          payment_method_id: setupIntent.payment_method,
          client_secret: clientSecret,
          payment_intent_id: setupIntent.id,
        };
        setFieldValue(payment);
        afterSubmit();
      }
    } catch (err: any) {
      console.error(err);
      setMessage(err.message || 'Error occurred');
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <View style={styles.container}>
      <ScrollView style={{ maxHeight: 400, overflowY: 'auto' }}>
        <PaymentElement />
        <TouchableOpacity
          onPress={handleSaveCard}
          disabled={!stripe || isProcessing}
          style={{
            marginTop: 12,
            paddingVertical: 10,
            paddingHorizontal: 16,
            backgroundColor: !stripe || isProcessing ? '#ccc' : '#007AFF',
            borderRadius: 4,
            alignItems: 'center',
          }}
        >
          <Text style={{ color: '#fff', fontSize: 16 }}>
            {isProcessing ? t('savingCard') : t('saveCard')}
          </Text>
        </TouchableOpacity>
        {message ? (
          <Text style={{ marginTop: 12, color: 'red' }}>{message}</Text>
        ) : null}
      </ScrollView>
    </View>
  );
};

export default PaymentArea;
